import React, { useState } from 'react';
import './Explorer.css';

const Explorer = ({ onNavigate, activeSection, isMobileMenuOpen }) => {
  const [expandedFolders, setExpandedFolders] = useState({
    portfolio: true,
    pages: true
  });

  const toggleFolder = (folder) => {
    setExpandedFolders(prev => ({
      ...prev,
      [folder]: !prev[folder]
    }));
  };

  const pages = [
    { id: 'hero', name: 'Home', icon: '🏠' },
    { id: 'about', name: 'About', icon: '👤' },
    { id: 'skills', name: 'Skills', icon: '⚡' },
    { id: 'experience', name: 'Experience', icon: '💼' },
    { id: 'projects', name: 'Projects', icon: '📁' },
    { id: 'education', name: 'Education', icon: '🎓' },
    { id: 'contact', name: 'Contact', icon: '📧' }
  ];

  return (
    <div className={`explorer ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
      <div className="explorer-header">
        <span className="explorer-title">EXPLORER</span>
      </div>
      
      <div className="explorer-content">
        <div className="folder-section">
          <div 
            className="folder-header"
            onClick={() => toggleFolder('portfolio')}
          >
            <span className="folder-arrow">{expandedFolders.portfolio ? '▼' : '▶'}</span>
            <span className="folder-icon">{expandedFolders.portfolio ? '📂' : '📁'}</span>
            <span className="folder-name">PORTFOLIO</span>
          </div>
          
          {expandedFolders.portfolio && (
            <div className="folder-content">
              <div 
                className="folder-item"
                onClick={() => toggleFolder('pages')}
              >
                <span className="folder-arrow indent-1">{expandedFolders.pages ? '▼' : '▶'}</span>
                <span className="folder-icon">{expandedFolders.pages ? '📂' : '📁'}</span>
                <span className="folder-name">Pages</span>
              </div>
              
              {expandedFolders.pages && (
                <div className="file-list">
                  {pages.map((page) => (
                    <div 
                      key={page.id}
                      className={`file-item ${activeSection === page.id ? 'active' : ''}`}
                      onClick={() => onNavigate(page.id)}
                    >
                      <span className="file-indent indent-2"></span>
                      <span className="file-icon">{page.icon}</span>
                      <span className="file-name">{page.name}</span>
                    </div>
                  ))}
                </div>
              )}
              
              <div className="file-item">
                <span className="file-indent indent-1"></span>
                <span className="file-icon">📦</span>
                <span className="file-name">package.json</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Explorer;
